import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from './store/store';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Defer ResizeObserver callbacks to the next animation frame. This breaks the
// synchronous measure -> resize -> measure cycle (triggered by @xyflow/react
// while re-measuring nodes during drag) that makes the browser emit the benign
// "ResizeObserver loop completed with undelivered notifications" error, which
// CRA's dev overlay surfaces as a fatal runtime error.
const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver) {
  class RafResizeObserver extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  }

  window.ResizeObserver = RafResizeObserver;
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
